export default __webpack_public_path__ + "static/media/ESSS28LSIA01_1920x1080.b120b7ed.jpg";